var _a, _b, _c, _d;
import colors from '../colors';
import { fontFamily, typography } from './typography';
export var MuiChip = {
    defaultProps: {
        size: 'small',
    },
    styleOverrides: {
        root: {
            fontFamily: fontFamily,
            background: colors.lilac[100],
            color: colors.night[900],
            borderRadius: '2px',
            gap: '4px',
            '& .MuiChip-deleteIcon': {
                margin: 0,
            },
            '.MuiChip-label': {
                padding: 0,
            },
            '.MuiChip-icon': {
                marginLeft: 0,
                marginRight: 0,
                fontSize: 'inherit',
            },
            '&.MuiChip-sizeSmall': {
                height: '20px',
                padding: '0 4px',
                '.MuiChip-label': {
                    fontSize: (_a = typography.caption) === null || _a === void 0 ? void 0 : _a.fontSize,
                    fontWeight: (_b = typography.caption) === null || _b === void 0 ? void 0 : _b.fontWeight,
                },
            },
            '&.MuiChip-sizeMedium': {
                height: '24px',
                padding: '0 6px',
                '.MuiChip-label': {
                    fontSize: (_c = typography.body) === null || _c === void 0 ? void 0 : _c.fontSize,
                    fontWeight: (_d = typography.body) === null || _d === void 0 ? void 0 : _d.fontWeight,
                },
            },
        },
    },
};
